import { render, staticRenderFns } from "./SplitButton.vue?vue&type=template&id=faced7f2&scoped=true&"
import script from "./SplitButton.vue?vue&type=script&lang=ts&"
export * from "./SplitButton.vue?vue&type=script&lang=ts&"
import style0 from "./SplitButton.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SplitButton.vue?vue&type=style&index=1&id=faced7f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faced7f2",
  null
  
)

export default component.exports